import styled from "styled-components";
// import { Link } from "react-router-dom";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useLazyQuery } from "@apollo/client";
import { InputPassword, InputText } from "../../components/form";
import { useAuth } from "../../redux/authReducer";
import { useEffect, useState } from "react";
import { LOGIN_QUERY } from "../../services/auth";
import { useNavigate } from "react-router-dom";
import { LogoClaims } from "../../assets/icons/Icons";
import { Button, TextLink } from "../../components/ui";

const schema = yup.object({
  email: yup
    .string()
    .required("Ingresa un email valido")
    .email("Ingresa un email valido"),
  password: yup.string(),
});

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  margin-top: -80px;
  & > div > svg {
    margin-bottom: 50px;
  }
  @media only screen and (max-width: 768px) {
    margin-top:0;
  }
`;

const LoginWrapper = styled.div`
  /* border: 2px solid #eff0f6; */
  border-radius: 20px;
  padding: 46px;
  display: flex;
  flex-direction: column;
  gap: 28px;
  width: 100%;
  max-width: 600px;
  box-shadow: 19px 70px 29px rgba(4, 3, 63, 0.01),
    11px 40px 25px rgba(4, 3, 63, 0.03), 5px 18px 18px rgba(4, 3, 63, 0.04),
    1px 4px 10px rgba(4, 3, 63, 0.05), 0px 0px 0px rgba(4, 3, 63, 0.05);
    @media only screen and (max-width: 768px) {
      padding: 26px;
      border: solid 1px grey;
      width:90%;

    }
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const StyledTitle = styled.h2`
  font-weight: 700;
  font-size: 28px;
  color: #4f5e74;
  text-align: center;
  margin-bottom: 40px;
`;


export default function LoginPage() {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const navigate = useNavigate();
  //Login
  const { login, authState } = useAuth();
  const [doLogin, resultsLogin] = useLazyQuery(LOGIN_QUERY);
  //Error Message
  const [customErrors, setCustomErrors] = useState({});

  const formSubmit = (data) => {
    try {
      doLogin({ variables: { email: data.email, password: data.password } });
    } catch {}
  };

  useEffect(() => {
    if (resultsLogin?.data?.login?.response?.usuario_id !== undefined) {
      login(resultsLogin.data.login.response);
    } else if (resultsLogin?.data?.login?.statusCode !== 200) {
      setCustomErrors({ password: resultsLogin?.data?.login?.message || "" });
      setTimeout(() => {
        setCustomErrors({});
      }, 4000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resultsLogin]);

  useEffect(() => {
    if (authState?.usuario_id !== undefined) {
      navigate(`/`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authState]);

  return (
    <Container>
      <LogoClaims w="240" h="60" />
      <StyledTitle>Bienvenido</StyledTitle>
      <LoginWrapper>
        <StyledForm onSubmit={handleSubmit(formSubmit)}>
          <InputText
            label="Ingresa tu correo"
            type="email"
            placeholder="Correo electrónico"
            register={{ ...register("email") }}
            errorMessage={errors.email?.message}
          />
          <InputPassword
            label="Ingresa tu contraseña"
            type="password"
            placeholder="Contraseña"
            register={{ ...register("password") }}
            errorMessage={
              errors.password?.message || customErrors?.password?.length > 0
                ? "Contraseña incorrecta"
                : ""
            }
          />
          <Button
            text={"Iniciar Sesión"}
            type="submit"
            style={{ alignSelf: "center", marginTop: "10px" }}
          />
        </StyledForm>
        <TextLink to="/olvide-mi-contrasena" text="Olvidé mi contraseña" />
      </LoginWrapper>
    </Container>
  );
}
